import { QueryParams, Pagination } from "@/models/query-params.model";
import { AgendaRest } from "@/services/rest/agenda.rest";
import { BehaviorSubject, Observable, take } from "rxjs"; 
import { CoursesRest } from "@/services/rest/courses.rest";
import { ClassesRest } from "@/services/rest/classes.rest";

export class AgendaService {
  constructor(
    private _agenda = new AgendaRest(),
    private _classes = new ClassesRest(),
    private _courses = new CoursesRest()
  ) {}


  private agenda$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  agenda: Observable<any> = this.agenda$.asObservable();
  private courses$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  courses: Observable<any> = this.courses$.asObservable();
  private classes$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  classes: Observable<any> = this.classes$.asObservable();


  getAllAgenda(params?: QueryParams): void {
    this._agenda.getAllAgenda(params).pipe(take(1)).subscribe({
      next: (response) => {
        this.agenda$.next(response);
      },
    });
  }

  deleteAgenda(id: string):void{
    this._agenda.delete(id).pipe(take(1)).subscribe({
      next:(response)=>{
        this.agenda$.next(response)
      }
    })
  }

  getClasses(params: QueryParams): void {
    this._classes
      .getAllClasses(params)
      .pipe(take(1))
      .subscribe((response) => {
        this.classes$.next(response)
      })
  }

  getCoursesByListId(listId: string[]): void {
    this._courses
      .getCoursesByListId(listId)
      .pipe(take(1))
      .subscribe((response) => {
        this.courses$.next(response);
      });
  }

  getCoursesByClassroomId(classroomId: string): void {
    this._courses
      .getCoursesByClassroomId(classroomId)
      .pipe(take(1))
      .subscribe((response) => {
        this.courses$.next(response);
      });
  }
}
